/**
 * Helper function to be used with `.filter` to filter out falsy values.
 */
export const isTruthy = <T>(item: T): item is Exclude<T, null | undefined> =>
	Boolean(item);
